import React, { FC } from 'react';
import { RaceTrackView } from '@utmb/types/index';

interface RaceTrackContextProps {
    track: RaceTrackView;
    color: string;
    isDark: boolean;
    name: string;
    url3d?: string;
    gpxUrl?: string;
}

const RaceTrackContext = React.createContext({} as RaceTrackContextProps);

interface RaceTrackProviderProps {
    track: RaceTrackView;
    color: string;
    isDark: boolean;
    url3d?: string;
    gpxUrl?: string;
    name: string;
}

export const RaceTrackProvider: FC<RaceTrackProviderProps> = ({ children, track, color, name, isDark, url3d, gpxUrl }) => {
    track.points = track.points.filter((pt) => pt.name !== 'HiddenLoopPoint');
    return (
        <RaceTrackContext.Provider
            value={{
                color,
                track,
                name,
                isDark,
                url3d,
                gpxUrl,
            }}
        >
            {children}
        </RaceTrackContext.Provider>
    );
};

export const useRaceTrack = () => {
    const context = React.useContext(RaceTrackContext);
    if (context === undefined) {
        throw new Error(`useRaceTrack must be used within an RaceTrackProvider`);
    }
    return context;
};
